
import Vue from "vue";
import AppDetailSettingsEditContent from "./DetailSettingsEditContent.vue";
import AppCustomLanguageSelect from "@/components/CustomLanguageSelect.vue";
import { Field } from "@/utils/documents/field";
import { SaleLayoutPaymentColSettings } from "@/utils/sale-layouts/payment-col";

export default Vue.extend({
	data() {
		return {
			hiddenKeys: [] as string[],
			cachedHeader: null as null | Field
		};
	},
	props: {
		value: {
			type: Object as ()=>SaleLayoutPaymentColSettings,
			required: true
		},
		selectedLanguage: {
			type: String,
			required: true
		},
	},
	methods: {
		close(){
			this.$emit("close");
		},
		onToggleHasHeader(value:boolean){
			if (!value){
				this.cachedHeader = this.value.HeaderField;
				this.value.HeaderField = null;
			}else {
				this.value.HeaderField = this.cachedHeader || new Field();
			}
		},
		onDetailSettingsBeforeLeave(el:HTMLElement){
			el.style.height = `${el.getBoundingClientRect().height}px`;
		},
		onDetailSettingsLeave(el:HTMLElement, done:Function){
			requestAnimationFrame(()=>{
				el.style.height = `0px`;
				el.style.paddingTop = `0px`;
				el.style.paddingBottom = `0px`;
			});
		},
		onDetailSettingsEnter(el:HTMLElement){
			let height = el.getBoundingClientRect().height;
			let paddingTop = el.style.paddingTop;
			let paddingBottom = el.style.paddingBottom;
			el.style.paddingTop = `0`;
			el.style.paddingBottom = `0`;
			el.style.height = `0`;
			requestAnimationFrame(()=>{
				el.style.height = `${height}px`;
				el.style.paddingTop = paddingTop;
				el.style.paddingBottom = paddingBottom;
			});
		},
		onDetailSettingsAfterEnter(el:HTMLElement){
			el.style.height = "";
		},
		setSelectedLanguage(lang:string){
			this.$emit("update:selected-language", lang);
		}
	},
	components: {
		AppCustomLanguageSelect,
		AppDetailSettingsEditContent
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
